<template>
  <Content @back="$router.go(-1)">
    <template v-slot:nav_left>{{centerInfo.youth.youthShortName || '--'}}</template>
    <template v-slot:nav_right>
      <router-link class="bg_btn" target="_blank" :to="{path: '/scout/list', query: {organUuid:centerInfo.youth.organUuid,youthUuid:centerInfo.youth.uuid}}" >
        球员评价
      </router-link>
      <router-link class="bg_btn" target="_blank" :to="{path: '/school/list', query: {organUuid:centerInfo.youth.organUuid,youthUuid:centerInfo.youth.uuid}}"  style="margin-left:10px">
        体教融合
      </router-link>
      <router-link class="bg_btn" target="_blank" :to="{path: '/siteFacilities/list', query: {organUuid:centerInfo.youth.organUuid,youthUuid:centerInfo.youth.uuid}}"  style="margin-left:10px">
        场地设施
      </router-link>
      <router-link class="bg_btn" target="_blank" :to="{path: '/talentSendPlayer/list', query: {}}" style="margin-left:10px">
        培养成效
      </router-link>
      <router-link class="bg_btn" target="_blank" :to="{path: '/statisticsYouth', query: {uuid:centerInfo.youth.uuid}}" style="margin-left:10px">
        大数据
      </router-link>
      <template v-if="userRole === 'system' || userRole === 'admin'">
        <div class="bg_btn" @click="handleUploadScore(true) " style="margin-left:10px;color:#f88594" v-if="!isInClubSystem && centerInfo.stageUuid">
          专家打分
        </div>
      </template>
      <template v-else>
        <div class="bg_btn" @click="handleUploadScore()" style="margin-left:10px;color:#f88594" v-if="!isInClubSystem && centerInfo.stageUuid">
          专家打分
        </div>
      </template>
    </template>
    <template v-slot:content_right>
      <div class="mainHead">
        <div class="headInfo">
          <div class="logo">
            <img :src="centerInfo.youth.banner || centerImg" alt="" @error="centerInfo.youth.banner = centerImg">
          </div>
          <div class="info">
            <p>精英机构全称：{{centerInfo.youth.youthName}}</p>
            <div class="row">
              <p >管理单位：
                <span v-if="['市直属'].includes(centerInfo.youth.organShortName)">{{centerInfo.youth.organShortName}}</span>
                <span v-else-if="['浦东新区'].includes(centerInfo.youth.organShortName)">上海市浦东新区体育管理指导中心</span>
                <span v-else>{{centerInfo.youth.organShortName}}体育局</span>
              </p>
              <p class="item">精英机构地址：
                <span v-if="centerInfo.youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                <span v-else-if="centerInfo.youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                <span v-else> {{centerInfo.youth.cityName}}{{centerInfo.youth.countyName}}</span>
              </p>
            </div>
            <div class="row">
              <p >精英机构状态：{{centerInfo.youth.status | statusFilter }}</p>
              <p class="item" v-if="!centerInfo.youthHeader">管理员姓名：{{centerInfo.user.idName}}</p>
              <p class="item" v-if="!centerInfo.youthHeader">管理员手机号：{{centerInfo.user.phone}}</p>
            </div>
            <div class="row" v-if="centerInfo.youthHeader">
              <p>法人：{{centerInfo.youthHeader.juridicalPerson}}</p>
              <p class="item">机构负责人姓名：{{centerInfo.youthHeader.youthHeader}}</p>
            </div>
            <div class="row" v-if="centerInfo.youthHeader">
              <p>青训总监姓名：{{centerInfo.youthHeader.youthDirectorName}}</p>
              <p class="item">青训总监教练证书：{{centerInfo.youthHeader.youthDirectorLevel}}</p>
            </div>
            <div class="row" v-if="centerInfo.youthHeader">
              <p>联络人姓名：{{centerInfo.youthHeader.linkman}}</p>
              <p class="item">联络人电话：{{centerInfo.youthHeader.linkmanPhone}}</p>
            </div>
            <div class="row">
              <p>球队数量：{{centerInfo.youth.squadNum}}</p>
              <p class="item">系统球员数量：{{centerInfo.youth.playerTeamNum}}</p>
              <p class="item">2026年注册球员数量：{{centerInfo.playerCareerNum}}</p>
              <p class="item">教练数量：{{centerInfo.youth.coachTeamNum}}</p>
            </div>
          </div>
          <div class="btn" v-if="isCanEditData">
            <div class="bg_btn" @click="editCenter=true">编辑信息</div>
          </div>
        </div>
      </div>
      <div class="mainInfo">
        <div class="select_wrap">
          <p class="title">
            <strong>球队管理</strong>
          </p>
          <div class="select_box">
            <input
              v-model.trim="selectVal.keyWord"
              type="text"
              class="yioks_input"
              placeholder="请输入关键词"
              @keyup.enter="getSquadList()"
            >
            <div class="yioks_btn" @click="getSquadList()">搜索</div>
          </div>
        </div>
        <div v-if="showList" class="list" :style="centerInfo.youthHeader ? 'height: 275px' : 'height: 375px'">
          <div class="scrollArea">
            <vue-scroll >
              <div
                v-for="(item, index) in squadList"
                :key="index"
                class="tr">
                <div class="item">
                  <div class="img">
                    <img :src="item.banner || squadImg" alt="" @error="item.banner = squadImg">
                  </div>
                  <div class="info">
                    <p class="title">{{item.shortName}}</p>
                    <p>主教练：{{item.chiefCoachName}}</p>
                    <p>球员数量：{{item.playerTeamNum}}</p>
                    <p :class="{ squadDissolve: item.squadDissolve }">球队状态：{{item.squadDissolve | squadDissolve}}</p>
                  </div>
                  <div class="opt" style="display:block">

                      <router-link  target="_blank" :to="{path: '/squad/detail', query: {uuid:item.uuid}}">
                        <div class="bg_btn">人员详情</div></router-link>


                    <router-link  target="_blank" :to="{path: '/plan/list', query: {organUuid:centerInfo.youth.organUuid,youthUuid:centerInfo.youth.uuid,youthShortName:centerInfo.youth.youthShortName,squadUuid:item.uuid}}" >
                      <div class="bg_btn" style="margin-top:10px">训练计划</div>
                    </router-link>

                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <yioks-empty v-if="empty" />
      </div>
      <Pagination :total="total" :pageSize="pageSize" :page.sync="page"/>
      <template v-if="editCenter">
        <AddPlayerDialog
          :addCenter.sync="editCenter"
          :centerUuid="uuid"
          :isEdit="isEdit"
          @hideDialog="hideDialog"></AddPlayerDialog>
      </template>
      <template v-if="isShowUploadScore">
        <downlad-view-club
          :isShow.sync="isShowUploadScore"
          :configInfo="downloadViewInfoForClub"
          @callbackForClub="handleViewCallBackForClub"
        >
        </downlad-view-club>
      </template>
    </template>
  </Content>
</template>

<script>

import 'vue-awesome/icons/regular/edit'
import center from '@/api/center'
import squad from '@/api/squad'
import centerImg from '@/assets/images/common/center.png'
import regions from '@/utils/regions'
import storage from '@/utils/storage'
import mixinAppConfig from "@/mixin/mixinAppConfig";
import { userStatus, centerStatusList } from '@/utils/yioks_data'
import { centerStatus } from '@/utils/yioks_filter'
import squadImg from '@/assets/images/common/squad.png'

export default {
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
    'AddPlayerDialog': () => import('@/components/center'),
    "downlad-view-club": () =>
      import("@/views/export/performance/components/ExpertAuditBaseScore"),
    // 'UploadFile': () => import('@/components/UploadFile')
  },
  filters: {
    statusFilter (val) {
      return centerStatus(val)
    },
    squadDissolve(val){
      if (val)
        return '已停止';
      else
        return '正常';
    },
  },
  mixins: [mixinAppConfig],
  data () {
    return {
      squadImg,
      regions,
      editCenter: false,
      centerImg,
      uuid: '',
      coach: '',
      total: 0,
      page: 0,
      pageSize: 20,
      empty: false,
      showList: false,
      addCenterBtn: false,
      centerStatusList,
      centerInfo: {
        user: {},
        youth: {},
        youthHeader: {},
        stageUuid:"",
        stageScoreStatus:"",
        playerCareerNum:"",
      },
      loading: false,
      isEdit: true,
      userStatus,
      selectVal: {
        key: ''
      },
      squadList: [],
      userRole: storage.get('userInfo').userRole,
      isShowUploadScore: false,
      downloadViewInfoForClub: {},
    }
  },
  created () {
    const uuid = this.$route.query.uuid
    this.uuid = uuid
    // this.getCoachAccount()
    this.getCenterInfo()
    this.getSquadList()
  },
  methods: {
    handleUploadScore(isDisabled){
      this.downloadViewInfoForClub = {
        stageUuid: this.centerInfo.stageUuid,
        youthUuid: this.uuid,
        isDisabled: isDisabled || false,
      };
      this.isShowUploadScore = true;
    },
    goStatistics(){
      this.$router.push({
        path: '/statisticsYouth',
        query: {
          uuid:this.uuid
        }
      })
    },
    goSiteFacilities(organUuid,youthUuid){
      this.$router.push({
        path: "/siteFacilities/list",
        query: {
          organUuid,
          youthUuid
        },
      });
    },
    goSchool(organUuid,youthUuid){
      this.$router.push({
        path: "/school/list",
        query: {
          organUuid,
          youthUuid
        },
      });
    },
    getCenterInfo () {
      center.getCenterInfo(this.uuid).then((res) => {
        this.centerInfo.user = res.user
        this.centerInfo.youth = res.youth
        this.centerInfo.youthHeader = res.youthHeader
        this.centerInfo.playerCareerNum = res.playerCareerNum
        if(res.stageUuid){
          this.centerInfo.stageUuid = res.stageUuid
        }
        if(res.stageScoreStatus){
          this.centerInfo.stageScoreStatus = res.stageScoreStatus
        }else{
          this.centerInfo.stageScoreStatus = "";
        }
      })
    },
    getSquadList () {
      this.loading = true
      this.empty = false
      this.showList = false
      let request
      if (this.userRole === 'system' || this.userRole === 'admin' || this.userRole === 'expert') {
        request = squad.getSquadBySystem
      } else if (this.userRole === 'organ') {
        request = squad.getSquadByOrg
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = squad.getSquadByYouth
      }
      request({ page: this.page, size: this.pageSize, key: this.selectVal.keyWord, youthUuid: this.uuid }).then((res) => {
        this.loading = false
        this.total = res.totalElements
        if (res.content.length) {
          this.squadList = res.content
          this.showList = true
        } else {
          this.empty = true
        }
      }).catch((err) => {
        this.loading = false
        console.error(err)
      })
    },
    goInfo (uuid) {
      this.$router.push({
        path: '/squad/detail',
        query: {
          uuid
        }
      })
    },
    goDetail(organUuid,youthUuid,youthShortName,squadUuid) {
      this.$router.push({
        path: "/plan/list",
        query: {
          organUuid,
          youthUuid,
          youthShortName,
          squadUuid
        },
      });
    },
    hideDialog (val) {
      this.editCenter = val
      this.getCenterInfo()
    },
    // club弹窗信息回调
    handleViewCallBackForClub(flag) {
      if (flag) {
        this.getCenterInfo();
      }
      this.isShowUploadScore = false;
    },
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .mainHead
    padding 15px 20px 0
    .headInfo
      display flex
      padding-bottom 20px
      border-bottom 1px solid white
      .logo
        display: flex;
        justify-content: center;
        align-items: center
        img
          width 105px
      .info
        width: calc(100% - 210px);
        padding 0 10px
        flex  1 1 auto
        .row
          margin 10px 0
          display flex
          .item
            margin 0 15px
      .btn
        width 105px
        display: flex;
        justify-content: center;
        align-items: center
  .mainInfo
    height:430px
    .select_wrap
      display flex
      justify-content space-between
      padding 10px 20px 5px
      .title
        font-size 20px
    .list
      height 375px
      .scrollArea
        height 100%
        .tr
          padding 0 20px
          .item
            display flex
            align-items center
            padding 15px 0
            border-bottom 1px solid #fff
            .img
              img
                width 100px
            .info
              width: calc(100% - 240px);
              padding 0 10px
              p
                margin-bottom 10px
                &:last-child
                  margin-bottom 0
              .title
                font-size 20px
              .squadDissolve
                color #f88594 !important
            .opt
              padding 0 10px
              width 140px
              display flex
              align-items center
              justify-content center
.bg_btn
  border 1px solid #fff
  padding 10px 16px
  text-align center
  cursor pointer
  &:hover
    background #5ac8fa
</style>
